import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Check } from "lucide-react";

const ACTIONS = ["view", "create", "update", "delete"];

export default function RolesPermissions() {
  const { t } = useLang();
  const [data, setData] = useState(null);
  const [meta, setMeta] = useState({ roles: [], modules: [] });
  useEffect(() => {
    let cancelled = false;
    api
      .get("/roles")
      .then(({ data }) => { if (!cancelled) setMeta(data); })
      .catch((error) => { console.error("Failed to load roles:", error); });
    api
      .get("/roles/permissions")
      .then(({ data }) => { if (!cancelled) setData(data); })
      .catch((error) => { console.error("Failed to load role permissions:", error); });
    return () => { cancelled = true; };
  }, []);

  const has = (role, mod, action) => (data?.matrix?.[role]?.[mod] || []).includes(action);

  return (
    <DashboardLayout title={t("roles.title")} subtitle={t("roles.subtitle")}>
      <div className="rounded-xl border border-zinc-800 overflow-x-auto" data-testid="roles-matrix">
        <table className="min-w-full text-xs">
          <thead>
            <tr className="text-left text-zinc-500 border-b border-zinc-800 bg-zinc-900/40">
              <th className="p-3 sticky left-0 bg-zinc-900/60 z-10">Module</th>
              {meta.roles.map(r => (
                <th key={r} colSpan={ACTIONS.length} className="p-3 text-center border-l border-zinc-800">
                  <div className="text-[10px] uppercase tracking-widest text-indigo-400">{r}</div>
                </th>
              ))}
            </tr>
            <tr className="text-zinc-500 border-b border-zinc-800 bg-zinc-900/20">
              <th className="p-2 sticky left-0 bg-zinc-900/40 z-10"></th>
              {meta.roles.map(r => (
                ACTIONS.map(a => <th key={r + a} className="p-1 text-[10px] font-normal border-l border-zinc-800 uppercase">{a[0]}</th>)
              ))}
            </tr>
          </thead>
          <tbody>
            {meta.modules.map(m => (
              <tr key={m} className="border-b border-zinc-800 hover:bg-zinc-900/30">
                <td className="p-3 text-zinc-100 sticky left-0 bg-zinc-950/80 z-10">{m}</td>
                {meta.roles.map(r => (
                  ACTIONS.map(a => (
                    <td key={r+m+a} className="p-2 text-center border-l border-zinc-800">
                      {has(r, m, a) ? <Check className="w-3.5 h-3.5 mx-auto text-emerald-500" /> : <span className="text-zinc-700">·</span>}
                    </td>
                  ))
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-4 text-xs text-zinc-500">V — view · C — create · U — update · D — delete</p>
    </DashboardLayout>
  );
}
